/* ===== Custom template — sync hide premium intruders (no async imports) ===== */

export const CUSTOM_INTRUDER_IDS = [
  'clientPremiumCenterCta',
  'clientPremiumSectionPromo',
  'layoutBlockCampaign',
  'playBtn',
  'layoutBlockPromo',
  'clientPromoGalleryTrigger',
  'clientLoyaltyModuleTrigger',
  'clientEventModuleTrigger',
  'layoutBlockLoyalty',
  'layoutBlockEvent',
  'clientConnectOfferCard'
];

export function isCustomTemplatePage(page = document.getElementById('clientPage')) {
  return !!page?.classList.contains('template-custom');
}

export function hideCustomIntruders(page = document.getElementById('clientPage')) {
  if (!isCustomTemplatePage(page)) return;

  CUSTOM_INTRUDER_IDS.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.hidden = true;
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('opacity', '0', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    el.style.setProperty('position', 'absolute', 'important');
    el.style.setProperty('left', '-9999px', 'important');
    el.style.setProperty('width', '0', 'important');
    el.style.setProperty('height', '0', 'important');
    el.style.setProperty('max-height', '0', 'important');
    el.style.setProperty('margin', '0', 'important');
    el.style.setProperty('padding', '0', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
  });

  if (page) {
    page.dataset.primaryModule = 'custom';
  }
}

export function clearCustomIntruderStyles() {
  CUSTOM_INTRUDER_IDS.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.hidden = false;
    el.removeAttribute('hidden');
    el.removeAttribute('aria-hidden');
    [
      'display',
      'visibility',
      'opacity',
      'pointer-events',
      'position',
      'left',
      'top',
      'right',
      'bottom',
      'width',
      'min-width',
      'height',
      'min-height',
      'max-height',
      'max-width',
      'margin',
      'padding',
      'overflow',
      'clip',
      'clip-path',
      'transform',
      'z-index',
      'flex',
      'order'
    ].forEach((prop) => el.style.removeProperty(prop));
  });
}
